import { render, staticRenderFns } from "./RiskArea.vue?vue&type=template&id=24a4742c&"
import script from "./RiskArea.vue?vue&type=script&lang=js&"
export * from "./RiskArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports